// Terminología por vertical — espejo web del `Terminology.of(orgType)` de Flutter
// y del mapa de EmailService (ver memory/tasks/0020-terminologia-por-vertical).
// OJO: los valores crudos de orgType del backend se confirman al cablear datos reales (W1).

export type Vertical = 'coach' | 'gym' | 'studio' | 'tutor' | 'nutrition' | 'other';

export interface Terminology {
  /** Cómo se llama el dueño del negocio. */
  business: string;
  /** Cliente final, singular. */
  customer: string;
  /** Cliente final, plural (nav, títulos de lista). */
  customerPlural: string;
}

const MAP: Record<Vertical, Terminology> = {
  coach: { business: 'coach', customer: 'alumno', customerPlural: 'alumnos' },
  gym: { business: 'gimnasio', customer: 'miembro', customerPlural: 'miembros' },
  studio: { business: 'estudio', customer: 'alumno', customerPlural: 'alumnos' },
  tutor: { business: 'profesor', customer: 'estudiante', customerPlural: 'estudiantes' },
  nutrition: { business: 'nutricionista', customer: 'paciente', customerPlural: 'pacientes' },
  other: { business: 'negocio', customer: 'cliente', customerPlural: 'clientes' },
};

// Acepta variantes del backend (COACH, GYM, GIMNASIO, STUDIO, ESTUDIO, TUTOR, PROFESOR,
// NUTRITION, NUTRICIONISTA, OTHER/GENERIC) y cae a 'other' si no reconoce.
const ALIASES: Record<string, Vertical> = {
  coach: 'coach',
  gym: 'gym',
  gimnasio: 'gym',
  studio: 'studio',
  estudio: 'studio',
  tutor: 'tutor',
  profesor: 'tutor',
  education: 'tutor',
  nutrition: 'nutrition',
  nutricion: 'nutrition',
  nutricionista: 'nutrition',
  other: 'other',
  generic: 'other',
  negocio: 'other',
};

export function normalizeVertical(orgType: string | null | undefined): Vertical {
  if (!orgType) return 'other';
  const key = orgType.trim().toLowerCase();
  return ALIASES[key] ?? 'other';
}

export function terminologyOf(orgType: Vertical | string | null | undefined): Terminology {
  return MAP[normalizeVertical(orgType ?? undefined)];
}
